import React, { useEffect } from "react"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { fetchSettings } from "redux/features/settings/settingsThunk"
import {
  selectSettingsById,
  selectFetchStatus,
} from "redux/features/settings/settingsSlice"
import LoadableEntity from "components/ui/LoadableEntity"
import { SettingsType } from "types"

export function withSettings<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithSettings = (props: GenericType) => {
    const dispatch = useAppDispatch()

    const settings = useAppSelector(
      (state) => selectSettingsById(state, 0) as SettingsType,
    )
    const fetchStatus = useAppSelector((state) => selectFetchStatus(state))

    const handleFetchSettings = () => {
      if (!fetchStatus.isFetching) {
        dispatch(fetchSettings())
      }
    }

    useEffect(() => handleFetchSettings(), [])

    return (
      <LoadableEntity entity={settings} fetchStatus={fetchStatus}>
        {(settings) => (
          <WrappedComponent
            {...props}
            settings={settings}
            fetchStatus={fetchStatus}
            fetchClient={handleFetchSettings}
          />
        )}
      </LoadableEntity>
    )
  }

  return WithSettings
}
